import { DELETE_ORGANIZATION_USER_API_SUCCESS, OrgnizationUserActionTypes } from '../organization-user/organization-user.actions';
import {
  BLOCK_TENANT_API_SUCCESS,
  FETCH_BLOCKED_TENANT_API_FAILED,
  FETCH_BLOCKED_TENANT_API_REQUESTED,
  FETCH_BLOCKED_TENANT_API_SUCCESS,
  FETCH_ORGANIZATION_USERS_API_FAILED,
  FETCH_ORGANIZATION_USERS_API_SUCCESS,
  FETCH_USER_BY_ID_API_REQUESTED,
  SET_IS_EDIT_MODAL_OPEN,
  UNBLOCK_TENANT_API_SUCCESS,
  UserActionTypes,
} from './user.actions';
import { UserState } from './user.types';

const initialState: UserState = {
  organizationUsers: [],
  haveCurrentOrganizationUsersBeenFetched: false,
  isEditModalOpen: false,
  blockedTenant: null,
  blockedTenantEmail: null,
  hasFetchedBlockedTenant: false,
};

export default (state = initialState, action: UserActionTypes | OrgnizationUserActionTypes): UserState => {
  switch (action.type) {
    case FETCH_ORGANIZATION_USERS_API_SUCCESS:
      return {
        ...state,
        organizationUsers: action.payload,
        haveCurrentOrganizationUsersBeenFetched: true,
      };
    case FETCH_ORGANIZATION_USERS_API_FAILED:
      return {
        ...state,
        haveCurrentOrganizationUsersBeenFetched: true,
      };
    case FETCH_USER_BY_ID_API_REQUESTED:
      return {
        ...state,
        blockedTenant: null,
        blockedTenantEmail: null,
        hasFetchedBlockedTenant: false,
      };
    case DELETE_ORGANIZATION_USER_API_SUCCESS: {
      const userId = action.payload;
      const newOrgUsers = state.organizationUsers.filter((id) => id !== userId);
      return {
        ...state,
        organizationUsers: newOrgUsers,
      };
    }

    case SET_IS_EDIT_MODAL_OPEN:
      return {
        ...state,
        isEditModalOpen: action.payload,
      };
    case FETCH_BLOCKED_TENANT_API_REQUESTED:
      if (action.payload.email === state.blockedTenantEmail) {
        return state;
      }
      return {
        ...state,
        blockedTenant: null,
        blockedTenantEmail: action.payload.email,
        hasFetchedBlockedTenant: false,
      };
    case FETCH_BLOCKED_TENANT_API_SUCCESS:
      if (action.meta.email !== state.blockedTenantEmail) {
        return state;
      }
      return {
        ...state,
        blockedTenant: action.payload,
        hasFetchedBlockedTenant: true,
      };
    case FETCH_BLOCKED_TENANT_API_FAILED:
      if (action.meta.email !== state.blockedTenantEmail) {
        return state;
      }
      return {
        ...state,
        blockedTenant: null,
        hasFetchedBlockedTenant: false,
      };
    case BLOCK_TENANT_API_SUCCESS:
      if (!isBlockedTenantEmail(state, action.payload.email)) {
        return state;
      }
      return {
        ...state,
        blockedTenant: action.payload,
        hasFetchedBlockedTenant: true,
      };
    case UNBLOCK_TENANT_API_SUCCESS:
      if (!isBlockedTenantEmail(state, action.meta.email)) {
        return state;
      }
      return {
        ...state,
        blockedTenant: null,
        hasFetchedBlockedTenant: true,
      };
    default:
      return state;
  }
};

function isBlockedTenantEmail(state: UserState, email: string): boolean {
  const currentEmail = state.blockedTenantEmail;
  if (!currentEmail) {
    return false;
  }
  return currentEmail.toLowerCase() === email.toLowerCase();
}
